import { Box, Container, Typography, Button, Stack, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion"

const CallToAction = () => {
  const navigate = useNavigate();

  const fadeUp = {
      hidden: { opacity: 0, y: 20 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    }

  return (
    <motion.section initial="hidden" whileInView="visible" variants={fadeUp} viewport={{ once: true }} style={{ padding: "64px 0", textAlign: "center", backgroundColor: "#f0f0f0" }}>
        <Container maxWidth="md">
          <Typography variant="h4" fontWeight={600} gutterBottom>
            Get Free Consultation From Our Experts
          </Typography>
          <Typography color="text.secondary" mb={4}>
            10+ years of experience helping businesses find comprehensive solutions.
          </Typography>
          <Button variant="contained" size="large" whileHover={{ scale: 1.05 }} onClick={() => navigate("/contact")}>
            Request Callback
          </Button>
        </Container>
      </motion.section>
  );
};

export default CallToAction;
